module.exports = __webpack_public_path__ + "static/media/parsecsv.ba3ddf07.svg";